import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Navigate } from "react-router-dom";
import Nav from "./Nav";
import Home from "./pages/Home";
import Scribe from "./pages/Scribe";
import Interview from "./pages/Interview";
import SOP from "./pages/SOP";
import Mirror from "./pages/Mirror";
import About from "./pages/About"


export default function App() {
  return (
    <BrowserRouter>
      <Nav />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/scribe" element={<Scribe />} />
        <Route path="/interview" element={<Interview />} />
        <Route path="/sop" element={<SOP />} />
        <Route path="/mirror" element={<Navigate to="/" replace />} />
        <Route path="/about" element={<About />} />
      </Routes>
    </BrowserRouter>
  );
}